import { FormControl, Autocomplete, TextField, createFilterOptions } from "@mui/material";
import React from "react";

const filterOptions = createFilterOptions<{ id: string; label: string }>({ matchFrom: "start", limit: 100 });

interface KeyValue {
    id: string;
    label: string;
}

interface AdvancedSearchSingleSelectProps {
    dataList: KeyValue[];
    label: string;
    id: string;
    handleSelectionChanged: (ids: number[]) => void;
    defaultValue: KeyValue | null;
    disabled?: boolean;
}

const AdvancedSearchSingleSelect: React.FC<AdvancedSearchSingleSelectProps> = (props) => {
    const onTagsChange = (event: React.SyntheticEvent, value: KeyValue | null) => {
        if (value) {
            var a = [Number(value.id)];
            props.handleSelectionChanged(a);
        } else {
            props.handleSelectionChanged([]);
        }
    };

    const selectId = "select-" + props.id;

    return (
        <FormControl fullWidth>
            <Autocomplete
                size="small"
                id={selectId}
                isOptionEqualToValue={(option, val) => option.id === val.id}
                filterOptions={filterOptions}
                options={props.dataList}
                getOptionLabel={(option) => option.label}
                onChange={onTagsChange}
                defaultValue={props.defaultValue ? props.defaultValue : null}
                disabled={props.disabled}
                renderInput={(params) => (
                    <TextField {...params} label={props.label} placeholder={props.label} />
                )}
            />
        </FormControl>
    );
};

export default AdvancedSearchSingleSelect;
